import React from 'react';
import { Row, Col } from 'reactstrap';

interface UtilityItem {
  id: string;
  utility_name: string;
  createdAt: string;
  updatedAt: string;
}

interface PropertyUtilitiesProps {
  propertyUtilitiesData: UtilityItem[];
}

const Utilities: React.FC<PropertyUtilitiesProps> = ({ propertyUtilitiesData }) => {
  if (!propertyUtilitiesData || propertyUtilitiesData.length === 0) {
    return (
      <div className="rounded p-4 text-center mb-1">
        <span className="text-muted">No Utilities Available</span>
      </div>
    );
  }

  // Split utilities into rows of 3
  const rows = [];
  for (let i = 0; i < propertyUtilitiesData.length; i += 3) {
    rows.push(propertyUtilitiesData.slice(i, i + 3));
  }

  return (
    <div>
      {rows.map((row, idx) => (
        <Row className="mb-2" key={idx}>
          {row.map((utility, j) => (
            <Col md={4} key={j} className="d-flex align-items-center mb-2">
              <i className="ri-check-line me-2" style={{ fontSize: 20, color: "#555" }}></i>
              <span style={{ fontSize: 15 }}>{utility?.utility_name}</span>
            </Col>
          ))}
        </Row>
      ))}
    </div>
  );
};

export default Utilities;